import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import PassOffer from "@/components/reader/PassOffer";

export default function RenewBanner({ me, daysLeft, onPaid, startOpen }) {
  const [open, setOpen] = useState(startOpen);
  const when = daysLeft === 0 ? "today" : daysLeft === 1 ? "tomorrow" : `in ${daysLeft} days`;
  return (
    <div className="border border-[#e0982f]/40 bg-[#e0982f]/10 mb-12" data-testid="reader-renew-banner">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-6 py-5">
        <p className="flex items-start gap-3 text-sm">
          <AlertTriangle className="w-4 h-4 text-[#e0982f] shrink-0 mt-0.5" />
          <span>
            Your pass ends <strong>{when}</strong>. Renew now to keep reading. Renewing adds {me.days} days to your current pass.
          </span>
        </p>
        {!open && (
          <button
            onClick={() => setOpen(true)}
            data-testid="reader-renew-button"
            className="shrink-0 bg-primary-gold text-[#0B0C10] font-mono-ui text-xs uppercase tracking-[0.18em] px-6 py-3"
          >
            Renew for ${me.price.toFixed(2)}
          </button>
        )}
      </div>
      {open && (
        <div className="px-6 pb-6 max-w-md">
          <PassOffer user={me.user} price={me.price} days={me.days} onPaid={onPaid} renew />
          <button onClick={() => setOpen(false)} data-testid="reader-renew-close" className="mt-4 text-xs text-soft hover:text-text-primary transition-colors">
            Not now
          </button>
        </div>
      )}
    </div>
  );
}
